module.exports = __webpack_public_path__ + "img/vision.8924d4b.png";